import { SchoolDistrict } from './schoolDistrict.model';
import { County } from 'src/app/model/county';
import { StoreConfig } from '@ngrx/store';
import { Region } from './region.model';
import { Country } from '../component/common-components/location/model/country.model';
export class School {
    ID?: number;
    NAME!: string;
    SCHOOL_NAME?: string;
    ORGANIZATIONS_ID!: number;
    ORGANIZATION_NAME!: string;
    SSID!: string;
    REGION!: string;
    SCH_PLANT!: number;
    LEA!: number;
    STATE_DISTRICT_ID!: number;
    STATE_SCHOOL_ID!: number;
    STATE_COUNTY_ID!: number;
    SCHOOL_WIDE_PROGRAMS!: string;
    SCHOOLWIDE!: string;
    DISTRICT!: string;
    PHONE!: string;
    PARTY_ROLES_ID!: number;
    STREET_1!: string;
    STREET_2!: string;
    CITY_NAME!: string;
    CITY_ID!: number;
    STATE_NAME!: string;
    STATES_ID!: number;
    POSTAL_CODE!: string;
    POSTAL_CODE_ID!: number;
    COUNTRY_CODE!: string;
    COUNTRY_ID!: number;
    GEOGRAPHICAL_REGIONS_NAME!: string;
    GEOGRAPHICAL_REGIONS_ID!: number;
    CREATED_BY!: string;
    CREATED_DATE!: Date;
    MODIFIED_BY!: string;
    MODIFIED_DATE!: Date;
    cdscODE!: string;
    SCHOOL_TYPE_ID!: number;
    SCHOOL_TYPE_OTHER!: SCHOOL_TYPE | '';
    SCHOOL_CODE!: number;
    SCHOOL_NCES!: string;
    LOW_GRADE!: number;
    HIGH_GRADE!: number;
    OPEN_DATE!: Date;
    CLOSE_DATE!: Date;
    STATUS_ID!: number;
    STATUS_CLOSE_DATE!: Date;
    SCHOOL_PROPERTY_ID!: number;
    ORGANIZATION!: ORGANIZATION;
    PARTIES!: string;
    ORGANIZATION_SCHOOL_DISTRICTS!: string;
    SCHOOL_DISTRICT!: SchoolDistrict;
    REGIONS!: Region; //Region;
    COUNTy!: County;
    SCHOOL_TYPE!: SCHOOL_TYPE;
    SCHOOL_TYPE_OTHERS!: SCHOOL_TYPE | '';
    LOW_GRADES!: Grade;
    HIGH_GRADES!: Grade;
    SCHOOL_STATUS!: SCHOOL_STATUS;
    SCHOOL_STATUS_TYPES!: SCHOOL_STATUS_TYPE;
    SCHOOL_PROPERTY_TYPES!: SCHOOL_PROPERTY_TYPE;
}

export class SCHOOL_STATUS_TYPE {
    ID?: number;
    DESCRIPTION!: string;
    CREATED_BY: string;
    CREATED_DATE: Date | undefined;
    MODIFIED_BY!: string;
    MODIFIED_DATE: Date | undefined;
    STATUS!: string;
}

export class Grade {
    ID?: number;
    GRADES!: string;
    DESCRIPTION!: string;
    ACTIVE?: boolean;
    INDEX?: number;
    CREATED_BY: string;
    CREATED_DATE: Date | undefined;
    MODIFIED_BY!: string;
    MODIFIED_DATE: Date | undefined;
    /*Property SCHOOL_GRADES As ICollection(Of SCHOOL_GRADES) = New HashSet(Of SCHOOL_GRADES)
    Property STUDENT_GRADES As ICollection(Of STUDENT_GRADES) = New HashSet(Of STUDENT_GRADES)
    Property PARTY_SERVICE_GRADES As ICollection(Of PARTY_SERVICE_GRADES) = New HashSet(Of PARTY_SERVICE_GRADES)
    */
}

export function compareSchool(s1: School, s2: School) {
    const compare = parseInt(s2.SCHOOL_NCES) - parseInt(s1.SCHOOL_NCES);

    if (compare < 0) {
        return 1;
    } else if (compare > 0) {
        return -1;
    } else return 0;
}

export interface PARTYROLETYPES {
    ID: number;
    TYPE: string;
    DESCRIPTION: string;
    CREATED_BY?: any;
    CREATED_DATE: Date;
    MODIFIED_BY?: any;
    MODIFIED_DATE?: any;
    PARTY_CONTACT_MECHANISMS: any[];
    PARTY_ROLES: any[];
    PARTY_SERVICES: any[];
    ELIGIBLE_TO_PROVIDE: any[];
    PARTY_ROLE_CATEGORIES: any[];
    PARTY_ROLE_PROJECT_TYPE: any[];
}

export interface PARTYROLE {
    ID: number;
    PARTIES_ID: number;
    PARTY_ROLE_TYPES_ID: number;
    CREATED_BY?: any;
    CREATED_DATE: Date;
    MODIFIED_BY?: any;
    MODIFIED_DATE?: any;
    ELIGIBILITies: any[];
    PARTy?: any;
    PARTY_PRE_SCREENS: any[];
    PARTY_RELATIONSHIPS: any[];
    PARTY_RELATIONSHIPS1: any[];
    PARTY_ROLE_ACCOUNT_REQUESTS: any[];
    PARTY_PROJECTS: any[];
    PARTY_ROLE_TYPES: PARTYROLETYPES;
    SERVICE_PROVIDERS: any[];
    SURVEY_ANSWER: any[];
}

export interface PARTy {
    ID: number;
    CREATED_BY?: any;
    CREATED_DATE: Date;
    MODIFIED_BY?: any;
    MODIFIED_DATE?: any;
    COMMUNICATION_EVENT_ROLES: any[];
    FACILITY_ROLES: any[];
    ORGANIZATIONS: any[];
    PARTY_PROGRAMS: any[];
    SERVICE_ITEMS: any[];
    PARTY_CONTACT_MECHANISMS: any[];
    PARTY_ROLES: PARTYROLE[];
    PARTY_STATUSES: any[];
    PARTY_WORK_EFFORT: any[];
    PERSONS: any[];
    REQUIREMENT_ROLES: any[];
    PROVISIONAL_SCHOOLS: any[];
}

export interface PartyContactMechanisms {
    ID: number;
    PARTIES_ID: number;
    PARTY_ROLE_TYPES_ID: number;
    CONTACT_MECHANISMS_ID: number;
    MERGED_RECORD: number;
    CREATED_BY?: string;
    CREATED_DATE: Date; // "/Date(1482326259893)/",
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
    CONTACT_MECHANISMS?: string[];
    STANDARDIZED_POSTAL_ADDRESSES?: string[];
    TELEPHONE_NUMBERS?: string[];
    CONTACT_PERSONS?: string[];
}

export interface PartyRoleTypes {
    ID: number;
    TYPE: string;
    DESCRIPTION: string;
    CREATED_BY?: string;
    CREATED_DATE: Date; // "/Date(-62135568000000)/",
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
    PARTY_CONTACT_MECHANISMS?: string[];
    PARTY_ROLES?: string[];
    PARTY_SERVICES?: string[];
    ELIGIBLE_TO_PROVIDE?: string[];
    PARTY_ROLE_CATEGORIES?: string[];
    PARTY_ROLE_PROJECT_TYPE?: string[];
}

export interface ContactMechanisms {
    COE_CONTACT_MECHANISMS: string[];
    CONTACT_MECHANISM_TYPES: string[];
    CONTACT_MECHANISM_TYPES_ID: number;
    CONTACT_PERSONS: string[];
    CREATED_BY?: string;
    CREATED_DATE: Date; // "/Date(1482240735710)/"
    EMAILS: string[];
    FACILITY_CONTACT_MECHANISMS: string[];
    ID: number;
    MERGED_RECORD: number;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: string;
    PARTY_CONTACT_MECHANISMS: string[];
    POSTAL_ADDRESSES: POSTAL_ADDRESSES;
    STANDARDIZED_POSTAL_ADDRESSES: string[];
    TELEPHONE_NUMBERS: string[];
}

export interface ContactMechanismsTypes {
    COMMUNICATION_EVENTS: string[];
    CONTACT_MECHANISMS?: string[];
    CREATED_BY?: string;
    CREATED_DATE: Date; // "/Date(1482240735710)/"
    ID: number;
    DESCRIPTION: string;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: string;
    PARTY_CONTACT_MECHANISMS: string[];
    TYPE: string;
    VALID_CONTACT_MECHANISM_ROLES: string[];
}

export interface ContactMechanismPurposeTypes {
    ID: number;
    CREATED_BY?: string;
    CREATED_DATE: Date; // "/Date(1482240735710)/"
    TYPE: string;
    DESCRIPTION: string;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: string;
}

export interface ORGANIZATION {
    ID: number;
    PARTIES_ID: number;
    NAME: string;
    CREATED_BY?: any;
    CREATED_DATE: Date;
    MODIFIED_BY?: any;
    MODIFIED_DATE?: any;
    SCHOOL_DISTRICTS_ID?: any;
    EMAIL_DOMAIN?: any;
    DEPARTURE_DATES: any[];
    EMAIL_DOMAINS: any[];
    LEGAL_ORGANIZATIONS: any[];
    MSIN_SCHOOLS: any[];
    REGIONS: any[];
    SCHOOL_DISTRICTS: any[];
    STUDENT_IDENTIFIER_ORGANIZATIONS: any[];
    PARTy: PARTy;
    SCHOOLS: any[];
}

export class CITy {
    ACCOUNT_REQUESTS?: string[];
    CITIES_COUNTIES?: string[];
    CITY_NAME: string;
    COE_MOVEMENT_INFORMATION?: string[];
    CREATED_BY?: string;
    CREATED_DATE: Date; //"/Date(-62135568000000)/"
    ID: number;
    MERGED_WITH?: string;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: Date;
    POSTAL_ADDRESSES: string[];
    PRE_SCREEN_MOVE_INFORMATION: string[];
    STATE: string[]; //{ID: 1, COUNTRIES_ID: 1, STATE_NAME: 'California', STATE_CODE: 'CA', CREATED_BY: null, …}
    STATES_ID: number;
}

export class STATE {
    ID: number;
    COUNTRIES_ID: number;
    STATE_NAME: string;
    STATE_CODE: string;
    CREATED_BY?: string;
}

export interface POSTAL_CODE {
    ACCOUNT_REQUESTS: string[];
    COUNTRIES_ID: number;
    COUNTRy: string[]; //{ID: 1, COUNTRY_NAME: 'United States', COUNTRY_CODE: 'USA', CREATED_BY: null, CREATED_DATE: '/Date(-62135568000000)/', …}
    CREATED_BY?: string;
    CREATED_DATE: Date; //  "/Date(-62135568000000)/"
    ID: number;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: string;
    POSTAL_ADDRESSES: string[];
    POSTAL_CODE: string;
    STANDARDIZED_POSTAL_ADDRESSES?: string[];
}

export class POSTAL_ADDRESSES {
    ID: number;
    CONTACT_MECHANISMS_ID: number;
    GEOGRAPHICAL_REGIONS_ID: number;
    POSTAL_CODES_ID: number;
    CITIES_ID: number;
    STREET_1: string;
    STREET_2: string;
    MERGED_RECORD: number;
    CREATED_BY?: string;
    CREATED_DATE: Date; // "/Date(-62135568000000)/"
    MODIFIED_BY?: string;
    MODIFIED_DATE?: string;
    COUNTRY_ID?: string;
    COUNTY_ID?: string;
    ADDRESS_CLEANED: [];
    CONTACT_MECHANISMS?: string;
    POSTAL_ADDRESS_BOUNDRIES: string[];
    COUNTRy?: string;
    POSTAL_ADDRESSES1?: string;
    POSTAL_ADDRESSES2?: string;
    CITy: CITy; // []; // {ID: 470, STATES_ID: 1, CITY_NAME: 'Roseville', CREATED_BY: null, CREATED_DATE: '/Date(-62135568000000)/', …}

    COUNTy?: string;
    GEOGRAPHICAL_REGIONS: GEOGRAPHICAL_REGIONS; // string[]; //{ID: 1, REGION: 'WEST', CREATED_BY: null, CREATED_DATE: '/Date(-62135568000000)/', MODIFIED_BY: null, …}

    POSTAL_ADDRESS_TYPE?: string;
    POSTAL_CODES: POSTAL_CODE[]; // {ID: 7057, POSTAL_CODE: '95661', COUNTRIES_ID: 1, CREATED_BY: null, CREATED_DATE: '/Date(-62135568000000)/', …}
}

export class POSTAL_CODE {
    ID: number;
    POSTAL_CODE: string;
    COUNTIES_ID: number;
    CREATED_BY?: string;
    CREATED_DATE: Date; // "/Date(-62135568000000)/"
    MODIFIED_BY?: string;
    MODIFIED_DATE?: string;
    ACCOUNT_REQUESTS: string[];
    POSTAL_ADDRESSES: string[];
    STANDARDIZED_POSTAL_ADDRESSES?: string[];
    COUNTRY?: Country;
}

export class GEOGRAPHICAL_REGIONS {
    ID: number;
    REGION?: string;
    CREATED_BY?: string;
    CREATED_DATE: Date; // "/Date(-62135568000000)/"
    MODIFIED_BY?: string;
    MODIFIED_DATE?: string;
    POSTAL_ADDRESSES?: string[];
    STANDARDIZED_POSTAL_ADDRESSES?: string[];
}

export interface EMAIL {
    ID: number;
    CONTACT_MECHANISMS_ID: number;
    EMAIL_ADDRESS?: string;
    MERGED_RECORD: number;
    CREATED_BY?: string;
    CREATED_DATE: Date; // "/Date(-62135568000000)/"
    MODIFIED_BY?: string;
    MODIFIED_DATE?: string;
}

export interface CONTACT_PERSON {
    ID: number;
    CONTACT_MECHANISMS_ID: number;
    FIRST_NAME?: string;
    LAST_NAME?: string;
    CREATED_BY?: string;
    CREATED_DATE: Date; // "/Date(-62135568000000)/"
    MODIFIED_BY?: string;
    MODIFIED_DATE?: string;
}

export interface TELEPHONE_NUMBERS {
    ID: number;
    CONTACT_MECHANISMS?: string;
    CONTACT_MECHANISMS_ID: number;
    CREATED_BY?: string;
    CREATED_DATE: Date; // "/Date(-62135568000000)/"
    EXT?: string;
    MODIFIED_BY?: string;
    MODIFIED_DATE?: string;
    PHONE_NUMBER?: string;
    PHONE_TYPE?: string;
}

export class SCHOOL_TYPE {
    ID?: number;
    TYPE: string;
    DESCRIPTION: string;
    IS_OTHER_TYPE?: number;
    OTHER_ID?: number;
    CREATED_BY: string;
    CREATED_DATE: Date | undefined;
    MODIFIED_BY: string;
    MODIFIED_DATE: Date | undefined;
}

export class SCHOOL_PROPERTY_TYPE {
    ID?: number;
    TYPE: string;
    DESCRIPTION: string;
    CREATED_BY: string;
    CREATED_DATE: Date | undefined;
    MODIFIED_BY: string;
    MODIFIED_DATE: Date | undefined;
}

export class SCHOOL_STATUS {
    ID?: number;
    SCHOOL_STATUS_TYPES_ID: number;
    SCHOOLS_ID: number;
    CLOSE_DATE: Date | undefined;
    CREATED_BY: string;
    CREATED_DATE: Date | undefined;
    MODIFIED_BY: string;
    MODIFIED_DATE: Date | undefined;
}
